import { observable } from "mobx";
import { copy, copyArray } from "../utils/data";
import { LearnedSkill } from "./opportunity";
import { Address } from "./organization";

export class Schedule {
    @observable startDate: Date;
    @observable regCloseDate: Date;
    @observable duration: string;
    @observable cost: number;
    @observable note: string;
    @observable location: Address;
    @observable locationId: string;
    @observable continuous: boolean;
    @observable online: boolean;

    constructor(s: Schedule) {
        copy(s, this, ["startDate", "regCloseDate", "location"]);
        this.location = new Address(s.location);
        this.startDate = new Date(s.startDate.valueOf());
        this.regCloseDate = new Date(s.regCloseDate.valueOf());
    }
}

export class Institution {
    @observable name: string;
    @observable address: Address;
    @observable website: string;
    @observable imageId: string;

    constructor(inst: Institution) {
        copy(inst, this, ["address"]);
        this.address = new Address(inst.address);
    }
}

export class CourseOffering {
  @observable title: string;
  @observable description: string;
  @observable schedule: Array<Schedule>;
  @observable skills: Array<LearnedSkill>;
  @observable number: string;
  @observable institutionId: string;
  @observable institution: Institution;
  @observable descriptionUrl:string;
  @observable registrationUrl:string;
  @observable credit:boolean;
  @observable creditHrs: number;
  @observable isOnline: boolean;
  constructor(co: CourseOffering) {
      copy(co, this, ["schedule", "skills", "institution"]);
      this.institution = new Institution(co.institution);
      this.schedule = new Array<Schedule>();
      this.skills = new Array<LearnedSkill>();
      copyArray(co.schedule, this.schedule, (s: Schedule) => { return new Schedule(s); });
      copyArray(co.skills, this.skills, (sk: LearnedSkill) => { return new LearnedSkill(sk); });
  }
}


// WEBPACK FOOTER //
// ./src/models/education.ts